import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { listItemDecks } from "@/services/item-deck/list-item-decks";
import { createItemDeck } from "@/services/item-deck/create-item-deck";
import { updateItemDeck } from "@/services/item-deck/update-item-deck";
import { deleteItemDeck } from "@/services/item-deck/delete-item-deck";
import { queryKeys } from "./query-keys";

export const useItemDecks = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.itemDecks,
    queryFn: async () => {
      const response = await listItemDecks();
      if (!response.ok) throw new Error(response.message);
      return response.data.decks;
    },
    enabled: state.status === "authenticated",
  });
};

export const useCreateItemDeck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createItemDeck,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.itemDecks });
    },
  });
};

export const useUpdateItemDeck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateItemDeck,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.itemDecks });
    },
  });
};

export const useDeleteItemDeck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteItemDeck,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.itemDecks });
    },
  });
};
